import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { initializePagination } from '@cred/react-pagination/actions'

import Pagination from 'components/styled-pagination'
import { defaultProducts } from 'mortgage-combined/rate-table/widget/common/constants'
import { getPageStats } from 'multi-vertical/rate-table/utils'

import ProductTile from '../product-tile'
import MortgageCombinedTile from '../mortgage-combined-tile/MortgageCombinedTile'
import styles from './styles.module.scss'

const mapDispatchToProps = (dispatch) => ({
  resetPagination: () => dispatch(initializePagination('mortgage-rate-table')),
})

const FullDashboard = connect(
  null,
  mapDispatchToProps,
)((props) => {
  const {
    products,
    paginationProps,
    loading,
    multiVerticalVariation = '',
    isMultiVertical = false,
    resetPagination,
    ...restProps
  } = props
  const { variation, page, LENDER_PER_PAGE, paginationName } = paginationProps
  const { pageCount, pageFrom, pageTo, showPagination } = getPageStats(
    variation,
    products,
    page,
    LENDER_PER_PAGE,
  )

  const slicedProducts = loading ? defaultProducts : products.slice(pageFrom, pageTo)

  const [startAtFirst, setStartAtFirst] = useState(false)

  if (pageFrom > products.length && !startAtFirst) {
    setStartAtFirst(true)
  }
  if (pageFrom === 0 && startAtFirst) {
    setStartAtFirst(false)
  }

  const paginationContainer = isMultiVertical
    ? styles.paginationContainer
    : styles.mortgageCombinedPaginationContainer

  useEffect(() => {
    setStartAtFirst(true)
  }, [products?.length])
  return (
    <div>
      {slicedProducts.map((product, index) => {
        return isMultiVertical ? (
          <ProductTile
            multiVerticalVariation={multiVerticalVariation}
            isMultiVertical={isMultiVertical}
            product={product}
            key={product.uuid}
            {...restProps}
            loading={loading}
          />
        ) : (
          <MortgageCombinedTile
            index={index}
            product={product}
            key={product.uuid}
            {...restProps}
            loading={loading}
          />
        )
      })}
      {showPagination && (
        <div className={pageCount > 1 ? paginationContainer : styles.paginationContainerHidden}>
          <Pagination
            forcePage={startAtFirst ? 0 : undefined}
            pageCount={pageCount}
            name={paginationName}
            className={isMultiVertical ? styles.pagination : styles.mortgageCombinedPagination}
            resetPagination={!isMultiVertical ? resetPagination : undefined}
          />
        </div>
      )}
    </div>
  )
})

FullDashboard.propTypes = {
  loading: PropTypes.bool.isRequired,
  products: PropTypes.array.isRequired,
  paginationProps: PropTypes.object.isRequired,
  multiVerticalVariation: PropTypes.string,
  isMultiVertical: PropTypes.bool,
}

FullDashboard.displayName = 'FullDashboard'

export default FullDashboard
